"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getControlPathById = ({ controlId, rootControl, currentPath = [], }) => {
    if (controlId === rootControl.id) {
        return currentPath;
    }
    const controls = rootControl.controls || [];
    for (let index = 0; index < controls.length; index += 1) {
        const controlPath = getControlPathById({
            controlId,
            rootControl: controls[index],
            currentPath: [...currentPath, index],
        });
        if (controlPath) {
            return controlPath;
        }
    }
    return undefined;
};
exports.default = getControlPathById;
